import Fire from "@/models/fire";
import firebase from "firebase/app";
import { RawUser } from "@/models/user";

const CHAT_COLLECTION = "chat";
const CHAT_LIST_COLLECTION = "chat_list";

export interface RawMessage {
  isFromCustomer: boolean;
  staffName?: string;
  text?: string;
  images?: string[];
  dateMSec: number;
}

interface ChatList {
  username: string;
  avatar: string;
  phone: string;
  group?: string;
  lastMessage: string;
  dateMSec: number;
  isRead: boolean;
}

export default class ChatModel {
  private static getRef() {
    const db = Fire.getFireStoreDb();
    return db.collection(CHAT_COLLECTION);
  }

  public static watchChat(phone: string, callback: Function) {
    const db = this.getRef().doc(phone);

    (window as any).unsubscribeFireStore = db.onSnapshot((doc) => {
      if (!doc.exists) {
        callback([]);
      }
      const data = doc.data();

      const rawMessages: RawMessage[] =
        data && data.messages ? data.messages : [];
      callback(rawMessages);
    });
  }

  public static stopWatchingChat() {
    (window as any).unsubscribeFireStore();
  }

  public static async sendMessage(userProfile: RawUser, message: RawMessage) {
    const db = this.getRef();

    const phone = userProfile.phone;

    const messageDoc = await db.doc(phone).get();

    if (messageDoc.exists) {
      await messageDoc.ref.update({
        messages: firebase.firestore.FieldValue.arrayUnion(message)
      });
    } else {
      await db.doc(phone).set({
        messages: [message]
      });
    }

    await this.addMessageToChatList(userProfile, message);
  }

  private static addMessageToChatList(
    userProfile: RawUser,
    message: RawMessage
  ) {
    const db = this.getChatListRef();
    const chatList: ChatList = {
      username: userProfile.name,
      avatar: userProfile.avatar,
      phone: userProfile.phone,
      lastMessage: message.text ? message.text : "Đã gửi hình",
      dateMSec: new Date().getTime(),
      isRead: false
    };

    if (userProfile.group) {
      chatList.group = userProfile.group;
    }

    return db.doc(userProfile.phone).set(chatList);
  }

  private static getChatListRef() {
    const db = Fire.getFireStoreDb();
    return db.collection(CHAT_LIST_COLLECTION);
  }
}
